const handleNavigateBackToSentenceHighlight = (timestamp: string) => {
  // Find the first highlighted element in the document with this timestamp
  const highlight = document.querySelector(
    `.annotator-submission-doc-wrap .highlighted[data-timestamp="${timestamp}"]`
  );
  if (highlight && highlight instanceof HTMLElement) {
    highlight.scrollIntoView({ behavior: 'smooth', block: 'center' });
    highlight.focus();
  }
};

export default handleNavigateBackToSentenceHighlight;
